import React from 'react'

function DriverProfile() {
  return (
    <div>DriverProfile</div>
  )
}

export default DriverProfile